import { Icons } from "assets";
import classNames from "classnames";
import Draggable from "../customDraggable";
import CustomRadioButton from "../customRadioButton";
import NoContentCard from "../noContentCard";
import styles from "./style.module.scss";

interface CustomTableProps {
  evaluations: any[];
  evalIds: string[];
  title: string;
  children: any;
  isEmpty?: boolean;
  loading: boolean;
  setEvalIds: (evalIds: string[]) => void;
  setSortBy: (sortBy: string) => void;
  setOrder: (order: string) => void;
  sortBy: string;
  order: string;
}

const CustomSelectTable = ({
  evaluations,
  evalIds,
  title,
  children,
  isEmpty,
  loading,
  setEvalIds,
  setSortBy,
  setOrder,
  sortBy,
  order,
}: CustomTableProps) => {
  const handleSorting = (key: string, revese = false) => {
    setSortBy?.(key);
    setOrder?.(revese ? "asc" : "desc");
  };

  return (
    <Draggable disableScroll={isEmpty && !loading}>
      <table
        className="table w-full"
        style={{ minWidth: "1100px", margin: "0px", width: "100%" }}
      >
        <thead className={classNames(styles.stickyHeader)}>
          <tr style={{ height: "48px" }}>
            <th
              className={classNames(
                "ps-2 pe-2",
                "sticky-col check-box-first-col",
                styles.tableHead
              )}
            >
              <div className={classNames("flex items-center justify-center")}>
                <CustomRadioButton
                  active={
                    isEmpty || loading
                      ? false
                      : evalIds.length === evaluations.length
                  }
                  className={classNames(styles.customRadioStyle)}
                  onClick={() => {
                    if (
                      evaluations.every((evaluation) =>
                        evalIds.includes(evaluation.id)
                      )
                    ) {
                      setEvalIds(
                        evalIds.filter(
                          (id) =>
                            !evaluations.some(
                              (evaluation) => evaluation.id === id
                            )
                        )
                      );
                    } else {
                      let tempArr = [
                        ...evalIds,
                        ...evaluations.map((item) => item.id),
                      ];
                      //@ts-ignore
                      setEvalIds([...new Set(tempArr)]);
                    }
                  }}
                />
              </div>
            </th>

            <th
              className={classNames(
                "ps-2 pe-2",
                "sticky-col check-box-second-col",
                styles.tableHead
              )}
            >
              <div className={classNames("flex items-center justify-between")}>
                Job Title
                {sortBy === "jobTitle" && order === "desc" ? (
                  <Icons.SortAscending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("jobTitle", true);
                    }}
                  />
                ) : (
                  <Icons.SortDescending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("jobTitle", false);
                    }}
                  />
                )}
              </div>
            </th>

            <th className={classNames("ps-2 pe-2", styles.tableHead)}>
              <div className={classNames("flex items-center justify-between")}>
                Department
                {sortBy === "department" && order === "desc" ? (
                  <Icons.SortAscending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("department", true);
                    }}
                  />
                ) : (
                  <Icons.SortDescending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("department", false);
                    }}
                  />
                )}
              </div>
            </th>
            <th className={classNames("ps-2 pe-2", styles.tableHead)}>
              <div className={classNames("flex items-center justify-between")}>
                Job Code
                {sortBy === "jobCode" && order === "desc" ? (
                  <Icons.SortAscending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("jobCode", true);
                    }}
                  />
                ) : (
                  <Icons.SortDescending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("jobCode", false);
                    }}
                  />
                )}
              </div>
            </th>

            <th className={classNames("ps-2 pe-2", styles.tableHead)}>
              <div className={classNames("flex items-center justify-between")}>
                RAS Score
                {sortBy === "rasScore" && order === "desc" ? (
                  <Icons.SortAscending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("rasScore", true);
                    }}
                  />
                ) : (
                  <Icons.SortDescending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("rasScore", false);
                    }}
                  />
                )}
              </div>
            </th>
            <th className={classNames("ps-2 pe-2", styles.tableHead)}>
              Status
            </th>
            <th className={classNames("ps-2 pe-2", styles.tableHead)}>
              <div className={classNames("flex items-center justify-between")}>
                Evaluated By
                {sortBy === "evaluatedBy" && order === "desc" ? (
                  <Icons.SortAscending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("evaluatedBy", true);
                    }}
                  />
                ) : (
                  <Icons.SortDescending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("evaluatedBy", false);
                    }}
                  />
                )}
              </div>
            </th>
            <th className={classNames("ps-2 pe-2", styles.tableHead)}>
              <div className={classNames("flex items-center justify-between")}>
                Evaluated Date
                {sortBy === "evaluationDate" && order === "desc" ? (
                  <Icons.SortAscending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("evaluationDate", true);
                    }}
                  />
                ) : (
                  <Icons.SortDescending
                    className={classNames("cursor-pointer")}
                    onClick={() => {
                      handleSorting("evaluationDate", false);
                    }}
                  />
                )}
              </div>
            </th>
            <th className={classNames("ps-2 pe-4", styles.tableHead)}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
      {isEmpty && !loading ? (
        <div className={classNames("my-5")}>
          <NoContentCard
            label1="No Data Found"
            label2={`There is no data available in the "${title}" table`}
          />
        </div>
      ) : null}
    </Draggable>
  );
};

export default CustomSelectTable;
